export default __webpack_public_path__ + "static/media/Frame (3).c381baef.png";